import type { FaireRetailerEntity } from "../../entity_types/retailer";

/**
 * Retailer context for Brand Updates playground data.
 * Refresh from production: `yarn nx run prototype-playground:entity-db -- upsert retailer --tokens r_83brjumc --api-env production`
 */
export const r_83brjumc: FaireRetailerEntity = {
  token: "r_83brjumc",
  type: "retailer",
  name: "Brand updates preview",
  meta: {
    source: "mock",
    importedAt: "2026-04-07T00:00:00.000Z",
    importedBy: "brand-updates-prototype",
  },
};
